export default {"src":"/_next/static/media/GovSmart_Icon_White.54a940a6.svg","height":80,"width":125,"blurWidth":0,"blurHeight":0};